export enum PermissionType {
  OBJECT_CREATOR,
}
